// jp.js
export default {
  // nav: {
  //   home: "ホーム",
  //   products: "製品情報",
  //   solution: "ソリューション",
  //   about_us: "企業情報",
  //   contact_us: "お問い合せ",
  //   language: "言語"
  // },
  navArr:[
    {
      title: "",
      path: "/pc/home",
      children:[],
    },
    {
      title: "製品情報",
      path: "/pc/productList",
      children:[
        {
          title:'収録／配信機',
          children:[
            {
              title:'汎用型収録／配信機',
              img:{
                path:'/pc/productList_info?ID=PECORDED_10',
                src:'record0.png'
              }
            },
            {
              title:'ポータブル収録／配信機',
              img:{
                path:'/pc/productList_info?ID=PECORDED_11',
                src:'record1.png'
              }
            },
            {
              title:'4Kプレミアム収録／配信機',
              img:{
                path:'/pc/productList_info?ID=PECORDED_12',
                src:'record2.png'
              }
            },
            // {
            //   title:'アウトドア用収録／配信機',
            //   img:{
            //     path:'/pc/productList_info?ID=PECORDED_13',
            //     src:'record3.png'
            //   }
            // },
            {
              title:'実習用収録／配信機',
              img:{
                path:'/pc/productList_info?ID=PECORDED_14',
                src:'record4.png'
              }
            }
          ]
        },
        {
          title:'デジタルホワイトボード',
          children:[
            {
              title:'教育用デジタルホワイトボード',
              img:{
                path:'/pc/productList_info?ID=PECORDED_20',
                src:'smart0.png'
              }
            },
            {
              title:'ビジネス用デジタルホワイトボード',
              img:{
                path:'/pc/productList_info?ID=PECORDED_21',
                src:'conference-display.jpg'
              }
            }
          ]
        },
        {
          title:'スマート黒板',
          children:[
            {
              title:'スマート黒板',
              img:{
                path:'/pc/productList_info?ID=PECORDED_30',
                src:'wisdom0.png'
              }
            },
            {
              title:'デュアルディスプレイ・スマート黒板',
              img:{
                path:'/pc/productList_info?ID=PECORDED_31',
                src:'dual-screen.jpg'
              }
            }
          ]
        },
        {
          title:'スマート講義台',
          children:[
            {
              title:'スマート講演台',
              img:{
                path:'/pc/productList_info?ID=PECORDED_40',
                src:'desk0.png'
              }
            },
            {
              title:'スマート講義台　電動式',
              img:{
                path:'/pc/productList_info?ID=PECORDED_41',
                src:'desk1.png'
              }
            }
          ]
        }
      ]
    },
    {
      title: "ソリューション",
      path: "/pc/schemeList",
      children:[
        {
          title:'プレミアム収録／配信システム・ソリューションプラン',
          children:[],
          img:{
            path:'/pc/4k-record',
            src:'1.jpg'
          }
        },
        {
          title:'汎用型収録／配信システム・ソリューションプラン',
          children:[],
          img:{
            path:'/pc/normalized-record',
            src:'2.png'
          }
        },
        {
          title:'２名教師連携・ソリューションプラン',
          children:[],
          img:{
            path:'/pc/dual-teacher',
            src:'3.jpg'
          }
        },
        {
          title:'ポータブル収録／配信システム・ソリューションプラン',
          children:[],
          img:{
            path:'/pc/portable-record',
            src:'4.jpg'
          }
        },
        {
          title:'AI行動分析システム・ソリューションプラン',
          children:[],
          img:{
            path:'/pc/ai-behavior',
            src:'5.jpg'
          }
        },
        {
          title:'スマート教室ソリューションュ',
          children: [
            {
              title:'スマート教室・ソリューションプラン（高等教育）',
              img:{
                path:'/pc/higherEdu',
                src:'6.jpg'
              }
            },
            {
              title:'スマートスクール・ソリューションプラン（小・中学校）',
              img:{
                path:'/pc/smartClasssroom',
                src:'7.jpg'
              }
            }
          ]
        },
      ],
    },
    {
      title: "企業情報",
      path: "/pc/about_us",
      children:[],
    },
    {
      title: "ニュース",
      path: "/pc/news",
      children:[],
    },
    {
      title: "お問い合せ",
      path: "/pc/contact_us",
      children:[],
    },
  ],
  foot: {
    foot_title: "GET CONNECTED WITH US",
    company: "企業情報",
    about_wenxiang: "会社概要",
    awards: "沿革",
    contact_us: "お問い合せ",
    news_events: "ニュースリリース",
    blogs: "blogs",
    customer_stories: "Customer Stories",
    input_placeholder: "Enter your E-mail Address",
    submit: "SUBMIT",
    details:
      "Sign up to receive WENXIANG marketing emails. You canmodify your subscription or unsubscribe at any time",
    web:'Web Policy',
    product:'Product Policy',
    cookie:'Cookies Policy',
  },
  home: {
    product: "製品情報",
    solution: "ソリューション",
    more_btn: "MORE",
    learn_more_btn:"LEARN MORE",
    product_a_title: "スマート黒板",
    product_b_title: "教育用デジタルホワイトボード",
    product_c_title: "ポータブル収録／配信機",
    slogan: "ー 情報技術と人工知能を活用し、スマートキャンパスを構築 ー",
    solution_a_title: "プレミアム収録／配信システム・ソリューションプラン",
    solution_b_title: "汎用型収録／配信システム・ソリューションプラン",
    solution_c_title: "２名教師連携・ソリューションプラン",
    solution_d_title: "ポータブル収録／配信システム・ソリューションプラン",
    solution_e_title: "AI行動分析システム・ソリューションプラン",
    solution_f_title: "スマート教室・ソリューションプラン（高等教育）",
    },
  contact_us: {
    contact_us: "お問い合わせフォーム",
    contact_details:
      "",
    contact_BJ_title: "Beijing Wenxiang Information \n Technology Co., Ltd.",
    contact_BJ_itemA:
      "Add: 11/F, Tower B, No.15 Ronghua South Road, Beijing Economic-Technological Development Area, Beijing, China",
    contact_BJ_itemB: "Web: http://www.wenxiang.cn",
    contact_BJ_itemC: "Tel: 010-81028190/91/92/93/94",
    contact_BJ_itemD: "Service Hotline: 400-860-8282",
    contact_AH_title: "Anhui Wenxiang Technology \n Co., Ltd.",
    contact_AH_itemA:
      "Add: Intersection of Fengming Avenue and Hanjiang Road, Jiangnan Industrial Concentration Zone, Chizhou, Anhui Province, China",
    contact_AH_itemB: "Web: http://www.wenxiang.cn",
    contact_AH_itemC: "Tel: 0566-5228888",
    contact_AH_itemD: "Service Hotline: 400-860-8282",
    form_info:{
      title:"お問い合わせフォーム",
      notice:"必須項目を入力してお問い合わせしてください。「※」印は必須項目です。",
      fields:['氏名','フリガナ','貴社名','部署名','郵便番号','都道府県','ご住所','電話番号','メールアドレス','お問い合わせ内容'],
      checkbox:'当社の個人情報保護方針に同意する',
      private:'ご登録いただいた個人情報については、お問合せに対する回答またはご連絡を差し上げる目的以外では利用致しません。その他、個人情報に関する取扱いにつきましては、弊社の個人情報保護方針をご確認ください。',
      commit:'提出を確認します'
    }
  },
  about_us: {
    about_us: "ABOUT US",
    about_details:
      "ー 情報技術と人工知能を活用し、スマートキャンパスを構築 ー",
    company_profile: "会社概要",
    BJ_company_profile_title: "文香株式会社 BUNKA CO., LTD.",
    BJ_company_profile_details:
      "本社所在地<br/> 〒101-0032<br/>  東京都千代田区岩本町2-13-６　<br/> TEL (03) 5823-4776<br/> 設立<br/>  2024年1月<br/>  代表者<br/>  代表取締役　佐藤　荻 <br/>資本金<br/> 900万円<br/> 主な事業内容<br/>  録画放送製品、スマート黒板、バーチャルキャストなどの教育⽤ハードウェア、ソフトウエアの企画、販売",
  },
  productList: {
    title_A: "製品情報",
    title_B: "録画放送機",
    WIS_DList: [
      "一体型録画放送機",
      "ポータブル録画放送機",
      "4Kプレミアム一体型録画放送機",
      "アウトドア録画放送機",
      "実習用録画放送機"
    ],
    title_C: "スマートパネル",
    whiteBoardList: ["教育用デジタルホワイトボード","オールインワン型カンファレンスディスプレイ"],
    title_D: "スマート黒板",
    blackBoardList: ["スマート黒板","デュアルディスプレイ・スマート黒板"],
    title_E: "スマート講義台",
    platformList: ["スマート講演台", "スマート講義台　電動式"]
  },
  product_info: {
    title_A: "製品概要",
    title_B: "製品特徴",
    title_C: "製品写真",

    A_A: {
      title_A: "一体型録画放送機",
      title_A_txt: "プルHD解像度マルチタッチモニター　内蔵ハードドライブ",
      CPJS_txt: `シンプルな壁がけ設計、高性能ビデオ・オーディオ処理チップを搭載し、17.3インチの高解像度マルチタッチモニター、内蔵ハードドライブを採用しました。録画、ライブブロードキャスト、およびインタラクティブ機能を実現します。`,
      WIS_DList: [
        {
          name: "PoE給電",
          conters:
            "複数台PoE対応のネットワークカメラの接続をサポートしており、電源、制御、ビデオ送信の統一運用が可能にします。"
        },
        {
          name: "タッチコントロール",
          conters:
            "17.3 インチのタッチ液晶モニターを採用し、フルタッチコントロールと可視化管理を実現します。"
        },
        {
          name: "データ共有",
          conters:
            "外部からUSBデバイスを利用して、録画放送機からデータを直接コピーでき、リモートWEBダウンロードもサポートします。"
        },
        {
          name: "セキュリティー対策",
          conters:
            "組込みシステムおよびソフトウェアは、他の組込み機器やプログラム等からの不正なアクセス、それによる重要データの修正、削除、追加ができないように設計されており、誤操作によるシステムの損傷、ウイルス等の感染を避けます。"
        }
      ]
    },
    A_B: {
      title_A: "ポータブル録画放送機",
      title_A_txt: `15.6インチの高解像度タッチモニター、リアルタイム監視と制御、操作が簡単。`,
      CPJS_txt: `4G/5G、Wi-Fiネットワークをサポートし、いつでもどこでもライブストリーミングが可能です。プログレードのワイヤレスモジュールを使用し、電源を入れると自動的にワイヤレスカメラとペアリングし、伝送浸透力と長距離を実現します。バッテリーが内蔵されており、外部モバイル電源が不要のため、好きな場所へ気軽に持ち運んで利用できます。`,
      WIS_DList: [
        {
          name: "AI追跡アルゴリズムにより自動追跡を実現"
        },
        {
          name: "AI行動分析システムを内蔵"
        },
        {
          name: "タッチモニターはAG+AFコーティングを採用"
        },
        {
          name:
            "屋内外の視認性を考慮した高輝度液晶画面を採用"
        }
      ]
    },
    A_C: {
      title_A: "4Kプレミアム一体型録画放送機",
      title_A_txt: `ワンチップ　超低遅延ブロードキャスト　複数端末からの同時リモート操作`,
      CPJS_txt: `4Kプレミアム録画放送機は、ワンチップ組み込みアーキテクチャ、ARM+DSP+Linuxオペレーティングシステムを採用しています。 Windowsシステムから完全に分離されているため、Microsoftシステムの更新停止や、ウイルスによる攻撃などの心配はありません。内蔵システムは、ビデオとオーディオの収集、リモートディレクション、オンラインライブブロードキャスト、オンラインオンデマンド、インタラクティブティーチング、4K録画などの機能を搭載しています。4Kプレミアム録画放送機は低電圧DC電源、低エネルギー消費、低発熱を実現し、教育活動の安全性と信頼性を確保しています。`,
      WIS_DList: [
        {
          name: "インタラクティブティーチング",
          conters: `RTSP/H.323/SIP などのインタラクションプロトコルをサポートします。`
        },
        {
          name: "4K超高解像度",
          conters: `4K超高精細な映像を撮影でき、4K高精細映像の合成・記録にも対応します。`
        },
        {
          name: "リモートディレクション",
          conters: `マルチチャンネルリアルタイムプレビュー、スタント、画面結合、カメラ制御などリモートディレクション機能を備えており、オンラインディレクション機能をサポートします。`
        },
        {
          name: "多様な情報表示",
          conters: `授業情報、字幕、オープニングおよびエンディング情報を表示し、授業内容の魅力を高めるため、特殊文字の設置をサポートします。`
        },
        {
          name: "録画モード",
          conters: `全自動、手動、半自動の制御方式をサポートし、シングルストリームシングルピクチャ（ムービーモード）、シングルストリームマルチピクチャ、マルチストリームマルチピクチャ（リソースモード）などの記録モードを実現します。`
        },
        {
          name: "セキュリティー対策",
          conters: `組込みシステムおよびソフトウェアは、他の組込み機器やプログラム等からの不正なアクセス、それによる重要データの修正、削除、追加ができないように設計されており、誤操作によるシステムの損傷、ウイルス等の感染を避けます。`
        }
      ]
    },
    A_D: {
      title_A: "アウトドア録画放送機",
      title_A_txt: `17.3インチタッチモニター搭載、ワンクリックで録画・放送を開始、停止できます。`,
      CPJS_txt: `室外用高性能システム搭載、またキャスターは自在キャスターを使用しているので移動もスムーズです。`,
      WIS_DList: [
        {
          name: "Domestic Design",
          conters: `
          Phytium motherboard and Kylin domestic system can meet the
          bidding parameters of localization.
          `
        },
        {
          name: "Portable Design",
          conters: `
          With four universal wheels, the equipment is convenient to use. When the equipment is placed horizontally,
          the wheels can be collected; And after opening the tripod, the product can be placed horizontally.
          `
        },
        {
          name: "Portable Power Supply",
          conters: `
          The power supply is independent and it can be charged on the hose or can be charged separately.
          `
        },
        {
          name: "Dual-screen Design",
          conters: `
          Office and audio/video application don’t interfere with each other. When users use KyLin System office software,
          the recording and broadcasting can normally use the audio/video recording, live broadcasting, screen switching and other functions.
          `
        }
      ]
    },
    A_E: {
      title_A: "実習用録画放送機",
      title_A_txt: `産業教育に役立つ新しい教育モデルを実証し、人材育成強化にサポートします。`,
      CPJS_txt: `実習用録画放送移動訓練車は全体が板金+プロファイル材で作られ、底部に装備された高品質・静音ユニバーサルホイールで、教育現場へ簡単に引っ張って移動することができます。録音放送機器は本体に内蔵され、取り外し可能なバッテリー設計により、指導時間が確保されます。3台カメラにより、指導のあらゆる場面が記録でき、さまざまな実習シナリオに適しています。`,
      WIS_DList: [
        {
          name: "３台カメラ",
          conters: `3台のカメラで授業のクローズアップ映像、授業のパノラマ映像、研修生徒のパノラマ映像を同時に記録できます。`
        },
        {
          name: "ローカルサウンド補強",
          conters: `30W出力スピーカーと教師用マイクブーストが内蔵され、教師の指導音声をリアルタイムで増幅できます。`
        },
        {
          name: "大容量バッテリー",
          conters: `交換、取り外す可能な設計を備えた大容量バッテリーで、指導現場をサポートします。`
        },
        {
          name: "画面ミラーリング",
          conters: `スマート黒板、デジタルホワイトボードへの画面ミラーリングをサポートし、教育効果を高めます。 `
        }
      ]
    },
    B_A: {
      title_A: "教育用デジタルホワイトボード",
      title_A_txt: `高解像度、シンプルなデザイン、強機能、安定性`,
      CPJS_txt: `教育用デジタルホワイトボード（デュアルシステム）は、シンプルな外観、強力なクアッドコアCPU、超高解像度広角カメラを内蔵し、超薄型赤外線タッチパネルは文香教育ソフトウェアと統合し、教師の指導をよりスムーズにします。`,
      WIS_DList: [
        {
          name: "4K高精細画質",
          conters: `高解像度・高輝度により鮮明かつ自然で、透明感のある繊細な画質を実現。 `
        },
        {
          name: "4K高精細カメラ",
          conters: `1300Wピクセル、120°超広視野角により鮮明で繊細な画像を撮影可能。 `
        },
        {
          name: "コアのアップグレード",
          conters: `クアッドコア1.9G HZチップ搭載、Android11バージョン`
        },
        {
          name: "インターフェースカバー",
          conters: `ほこりや衝突から機器を効果的に保護可能。 `
        },
        {
          name: "TYPE-Cインターフェース",
          conters: `面倒な配線作業が不要となり、多くの機能をワンステップで簡単に実現できます。`
        },
        {
          name: "セキュリティ強化",
          conters: `タッチロック、画面ロック、USBロック、アプリロック機能を装備し、機器のセキュリティを向上します。`
        }
      ]
    },
    B_B:{
      // 会议交互平板
      title_A: "オールインワン型カンファレンスディスプレイ",
      title_A_txt: `会議記録を効率的に行い、スマートオフィスとしてのテクノロジー進化を体験。`,
      CPJS_txt: `パソコン、プロジェクター、電子ホワイトボード、テレビ、広告設備、オーディオ設備の機能を統合し、書き込み、注釈、テレビ会議、ワンクリック画面転送などの機能を備えており会議効率を向上させます。政府機関、企業、工場の会議室、メディアスタジオ、教育訓練施設、展示ホールなどでご活用いただけます。 `,
      WIS_DList: [
        {
          name: "Multi-touch",
          conters: `ultra-thin and ultra-narrow infrared design more than 20 touch points make accurate writing`
        },
        {
          name: "高解像度カメラ",
          conters: `13MP with wide viewing angle remote pickup`
        },
        {
          name: "Core performance upgrade",
          conters: `quad-core processor Android 11.0`
        },
        {
          name: "Multiple Software Applications",
          conters: `annotation, screen-share, and writing are all contained`
        },
      ]
    },
    C_A: {
      title_A: "スマート黒板",
      title_A_txt: `スリムなデザイン、高解像度ディスプレイ、シームレスな切り替え`,
      CPJS_txt: `スマート黒板は、従来の伝統的な黒板の機能に加え、スマート教育システム、マルチタッチ、高解像度LCDディスプレイ、パワーアンプ、スピーカーなど多数の技術を集約しています。教師は５本指のタッチ操作で、簡単に伝統的な黒板とタッチパネルシステムをシームレスに切り替えることができます。黒板の書き込み、電子黒板でのインタラクティブコミュニケーション、教材・資料の引き出し、マルチデバイスのデモストレーション操作などを行うことができます。`,
      WIS_DList: [
        {
          name: "4K高精細画質",
          conters: `高解像度・高輝度により鮮明かつ自然で、透明感のある繊細な画質を実現。 `
        },
        {
          name: "コアのアップグレード",
          conters: `搭载四核1.9G HZ 芯片，升级至Android 11 版本，系统更流畅
          クアッドコア1.9G HZチップ搭載、Android11バージョン
          `
        },
        {
          name: "ステレオスピーカー",
          conters: `2.1chサウンドバーにアップグレードにして、高音質でクリアなサウンドを再生できます。 `
        },
        {
          name: "シームレスな接続環境",
          conters: `WindowsとAndroidシステムが同時利用可能で、システム間でのファイル・アプリケーションの転送が可能になり、デスクトップ上の追加もサポートします。`
        },
        {
          name: "種類豊富なデスクトップアイコン",
          conters: `天気、ウェルカムメッセージ、カレンダー、日々の言葉など、さまざまな実用的なアイコンを追加、削除できます。`
        },
        {
          name: "目の保護+",
          conters: `タッチロック、画面ロック、USBロック、アプリロック機能を装備し、機器のセキュリティを向上します。`
        },
        {
          name: "セキュリティ強化",
          conters: `タッチロック、画面ロック、USBロック、アプリロック機能を装備し、機器のセキュリティを向上します。`
        },
        {
          name: "4K高精細カメラ+アレイマイク（オプション）",
          conters: `1300Wピクセル、120°超広視野角により鮮明で繊細な画像を撮影可能。8つのアレイマイクにより、教室の隅々まで鮮明に録音できます。 `
        },
        {
          name: "ドキュメントスキャナー（オプション）",
          conters: `新たにアップグレードされた1300Wピクセル高精細ドキュメントスキャナー、柔軟且つ効率な教育展開が可能となります。`
        }
      ]
    },
    C_B: {
      // 双屏智慧黑板
      title_A: "デュアルディスプレイ・スマート黒板",
      title_A_txt: `教育におけるマルチメディアのインテグレーションと各種スプライシングのカスタマイジング`,
      CPJS_txt: `当社のスマート黒板は、インテリジェント教学システム、プロジェクタ、電子ホワイトボード、4K高精細大画面テレビ、パソコン、パワーアンプ、ビジュアライザー（ドキュメントスキャナー）などを伝統的な黒板と一体化したマルチメディア操作プラットフォームです。現場の環境に合わせた各種のスプライシングをカスタマイズすることができ、ダブルスプライシングがメインとなります。`,
      WIS_DList: [
        {
          name: "便利な設計",
          conters: `独立したOPSコントローラモジュール（PC）や電気キャビネットは取り外し可能で、アップグレードやメンテナンスに便利です。`
        },
        {
          name: "安全・健康",
          conters: `4mm強化ガラスと丸い角を持つアルミプロファイルで教師と生徒の衝撃や怪我を防止することができます。また、工業用ガラス接着剤で固定されており、ブルーライトをカットし目に優しく、防塵防水にも対応しています。`
        },
        {
          name: "ワンクリック切り替え",
          conters: `ワンクリックで一般教室黒板とスマート黒板のディスプレイをスムーズに切り替えることができます。板書は流暢で黒板拭きもきれい。4K高精細ディスプレイはタッチ反応がよくてサクサク動きます。`
        },
        {
          name: "豊富なインターフェース",
          conters: `デュアルチャネルUSB、Android、OPSはいつでも呼び出すことができます。HDスピーカーは優れたサウンド効果を実現します。また、スイッチ、音量調整、明るさ調整、切り替えを含め、多種なシステムファンクションボタンを設けています。`
        },
        {
          name: "ワイヤレスIoT",
          conters: `ワイヤレスWIFI信号伝送モジュールを付属しており、WIFIホットスポットの設定が可能であり、スマートフォンなどのワイヤレスデバイスが設備との相互接続が便利になります。RS232インターフェースを準備しており、学校のスマートキャンパス建設や設備の遠隔スイッチコントロールなどの操作にご使用していただくことができます。`
        },
      ]
    },
    D_A: {
      title_A: "スマート講演台",
      title_A_txt: `人間工学に基づいたデザイン、23.8インチ静電容量式10ポイントタッチパネルを採用、ほとんどの機能をワンクリックで実行できるシンプルな操作性を実現します。`,
      CPJS_txt: `スマート講義机はシンプルなデザイン、本体は冷間圧延鋼板で作られ、耐摩耗性、耐湿性、耐火性、抗菌性、帯電防止に優れています。`,
      WIS_DList: [
        {
          name: "高品質のデスクトップ",
          conters: `デスクトップは、耐摩耗性、耐湿性、耐火性、抗菌性、帯電防止に優れています。`
        },
        {
          name: "空間デザイン",
          conters: `19インチ機器用の設置スペースを確保しています。`
        },
        {
          name: "設備検査窓",
          conters: `講義テーブル上にコンピュータの検査窓を確保されているため、本体を開けずにコンピュータを操作できます。`
        },
        {
          name: "効率向上",
          conters: `ディスプレー画面の傾き設計により、最適な視野角で内容が表示できます。講師は正面向き指導することができ、指導効率が向上します。`
        }
      ]
    },
    D_B: {
      title_A: "スマート講義台　電動式",
      title_A_txt: `分割画面ティーチングシステム、インテリジェント制御システム、録画放送システム、インタラクティブシステム、追跡システム、音声処理システムの機能を統合し、より高いレベルのハイブリッド授業を実現します。`,
      CPJS_txt: `スマート講義台は3段階デザインを採用し、講義台本体はアルミニウム合金プロファイルで作られ、表面はサンドブラストと陽極酸化プロセスによって処理され、シャープなデザイン。インテリジェント制御システム、録画放送システム、インタラクティブシステム、追跡システム、音声処理システムの機能を統合し、より高いレベルのハイブリッド授業を実現します。`,
      WIS_DList: [
        {
          name: "多画面連携ティーチング",
          conters: `高解像度の静電容量式電磁デュアルモードタッチモニターと角度調整可能なディスプレイを搭載し、大画面と小画面をリアルタイムで連携させることで指導が簡単になります。`
        },
        {
          name: "スマートIoTシステム",
          conters: `10.1インチの中央コントロールパネルにより、教室内のさまざまな端末機器の制御や、録画、インタラクショ、ライブブロードキャストのリアルタイム操作が可能になります。`
        },
        {
          name: "隠れたデザイン",
          conters: `隠しグースネックマイク、ドキュメントスキャナー、インターフェースにより、スペースを有効活用できています。`
        },
        {
          name: "統合化",
          conters: `センターピラードアの設計は、機器の設置とメンテナンスを簡単に、機器の安全性を確保するための安全ロックが装備されています。下部の引き出しタイプのキャビネットには、録画放送機本体、追跡マシン本体などを配置できます。`
        }
      ]
    }
  },

  // 方案
  // 主页
  homepage: {
    title: "WE OFFER SOLUTIONS",
    list: [
      {
        title: "プレミアム収録／配信システム・ソリューションプラン",
        introduce: []
      },
      {
        title: "汎用型収録/配信システム・ソリューションプラン",
        introduce: []
      },
      {
        title: "２名教師連携・ソリューションプラン",
        introduce: []
      },
      {
        title: "ポータブル収録／配信システム・ソリューションプラン",
        introduce: []
      },
      {
        title: "AI行動分析",
        introduce: []
      },
      {
        title: "スマート教室ソリューションュ",
        introduce: [
          'スマート教室・ソリューションプラン（高等教育） <br/> 小中学校向けスマート教室・ソリューションプラン',
        ]
      }
    ]
  },

  // 三个课堂
  three_classRoom: {
    title: "FEATURES AND ADVANTAGES",
    titleOne: "THREE-CLASSROOM",
    titleTwo: "SOLUTION",
    appTitle: "APPLICATION PACKAGE",
    content:
      "The program is suitable for a variety of Program application scenarios such as cross-regional interactive teaching activities, co-construction and sharing of high-quality course resources.",
    contentTwo:
      "This solution is suitable for a variety of scenarios such as sharing master teacher resources, forming online teaching and research, teaching level assessment, teaching observation and evaluation, and educational outreach.",
    contentThree:
      "This solution is suitable for a variety of scenarios such as setting up a famous school online classroom portal, synchronous courses, thematic courses, school-specific courses and realizing the display of high-quality courses.",
    synopsisOne:
      "Classroom-to-classroom online construction solution is based on the county and district, giving full play to the radiation role of urban central schools. And it promotes a variety of teaching and teaching and research organization models, helps schools to conduct the state-prescribed curriculum with totally determination, and promotes the fair and balanced development of education.",
    synopsisTwo:
      "To give full play to the role of special-grade teachers, provincial and municipal subject leaders and leading teachers, this solution uses the Wenxiang’s Full-time Education Cloud Platform to help more teachers in the provinces, cities to conduct a series of teaching and research activities. And it will help teachers to break through the bottleneck of professional development and improve the overall quality of education and teaching in schools.",
    synopsisThree:
      "There is an experimental school including schools affiliated to provincial universities, municipalities and key county schools, and it will be set as the teaching subjects. The schools concerned will draw up lesson recording plans, set up recording systems and organize excellent teachers to produce online lessons at the same time. After the reviewing of subject contents and recording technology, high-quality resources will be widely shared.",
    list: [
      "Classroom-to-classroom Online Construction Program",
      "Teacher-to-teacher Online Construction Program",
      "School-to-school Online Construction Program"
    ],

    functionList: [
      "Intelligent Course Recording",
      "Online Remote Live Broadcasting",
      "Two-way Distance Interactive Teaching",
      "Multi-board Writing and Screen Interaction",
      "Visual Management and Remote Guidance",
      "Data Statistics"
    ],

    functionListTwo: [
      {
        title: "Conducting Diversified Web-based Teaching and Research",
        name:
          "With master teachers as the core, we make full use of their resources and vigorously carry out the 1+N application to solve the shortage of outstanding teachers and achieve the sharing of quality educational resources in the region."
      },
      {
        title: "Online Remote Live Broadcasting",
        name:
          "Through the demonstration effect of master teachers, network interactive teaching, excellent lesson recording and remote training can be carried out to realize the network-helping teaching activities. Using the master teachers recorded courses with high-quality at the same time for other classrooms to study and observe the course, which gives full play to the leading role of master teachers."
      },
      {
        title: "Accessibility",
        name:
          "Through the integrated design of teaching, research and training, teachers are helped to carry out teaching and research on the practical problems they encounter in the teaching process, and to reflect on and re-practice their teaching, so as to improve their teaching standards."
      }
    ],

    functionListThree: [
      {
        title:
          "Conducting Public Classroom Activities to Promote Student-led Learning",
        name:
          "By creating a space for high-quality resources, students can selectively participate according to their own situation and learn in fragments. Online classes can build independent learning channels for students."
      },
      {
        title:
          "Expanding the Utilization of High-quality Resources and Exemplary Effect of Prestigious Schools",
        name:
          "The recording system can realize the standardized recording of daily teaching audio and video data combined with digital teaching materials, which are processed to form high-quality lessons and micro-lessons that teachers can upload and share on the school resource management platform. It helps schools to deposit high-quality educational resources, complete the construction of school-based resources, expand the utilization rate of high-quality resources and bring into play the demonstration effect of prestigious schools."
      },
      {
        title: "Promoting Personalized Development of Students",
        name:
          "Once completed, the online classroom can be opened to the public to create a high-quality curriculum with high-quality resources from the region's famous schools. It definitely thus builds a self-learning channel for students, facilitates fragmented and independent learning and promotes their personalized development."
      }
    ]
  },

  // 中小学全学科智慧教室建设方案
  mediumSchool: {
    title:
      "スマートスクール・ソリューションプラン（小・中学校）",
    content:
      "スマート教室プランはサービス教育を中心とした新型教室プランです。授業前、授業中、授業後のフルプロセスの教育内容をカバーし、メディア、コンテンツ、インタラクティブ連携・連動の機能を実現しました。特徴としては教育内容の最適化、教室コミュニケーションの活性化、教育資源利用の簡単化などが挙げられます。そのほか、状況認知、知能制御などの機能が備えられており、健康的でスマート、高効率でエコな新型教室プランを構築することができます。",
    componentsTitle:'システムの構成',
    components:[
      'スマート黒板','スマート講演台','収録システム','学習行動分析システム','管理プラットフォーム','integrated design'
    ],
    features_title:'主な特長',
    featuresList: [
      {
        title: "スマート黒板",
        name:'スマート黒板は、従来の伝統的な黒板の機能に加え、スマート教育システム、マルチタッチ、高解像度LCDディスプレイ、パワーアンプ、スピーカーなど多数の技術を集約しています。教師は５本指のタッチ操作で、簡単に伝統的な黒板とタッチパネルシステムをシームレスに切り替えることができます。黒板の書き込み、電子黒板でのインタラクティブコミュニケーション、教材・資料の引き出し、マルチデバイスのデモストレーション操作などを行うことができます。'
      },
      {
        title: "アンチグレアと目の保護",
        name:'スマート黒板のガラス表面は、ナノコンポジットコーティングを施し、両眼に有害なブルーライトなどの光源をカットし、教師と生徒の視力を保護してくれます。'
      },
      {
        title: "デュアルシステム",
        name:"Windows/Androidのデュアルシステムをプラットフォームとし、豊富な教育アプリケーションソフトを利用することができます。"
      },
      {
        title: "豊富な教学資源",
        name:'多数のインタラクティブ電子黒板アプリや、動画、音楽、写真、PPTなど豊富な教育素材が付属されており、教師の授業にご活用いただけます。'
      }
    ],
    automatic: {
      title: "全自動4Kプレミアム収録/配信",
      name:'The classroom contains a fully automatic six-camera recording system, which supports the filming and recording of multiple video channels, including teacher close-ups and full views, student close-ups and full views, writing close-ups and student patrol pictures. All shoots are in high quality, achieving true full HD recording. It also supports access to computer signals for recording. The student walk-through function allows you to take close-ups of each student in real time, forming student behaviour data for later analysis.'
    },
    longEssay: [
      {
        title: "スマートランドセル",
        name:
          "教育用クラウドサービス及びアプリケーションをベースに、スマート黒板、学生用スマート学習端末およびPADスマート教室システムを搭載しています。スマートランドセルはシンプル且つ実用的であり、高効率でスマートな教室を構築することができます。教師は生徒の事前予習状況の統計に基づき授業内容を計画し、インタラクティブな交流型や自主的学習型など多種多様な授業内容を柔軟に設計することができます。また、リアルタイムに生徒の学習状況をモニタリングしたり、生徒とインタラクティブにコミュニケーションを取ったりすることで、より適切に授業解説を行うことができます。こうして生徒の学習プロセスや学習の能力、態度を重視することにより、教師は生徒の潜在的な能力を開発しながら負荷を減らし、生徒の自主性の育成、成績の向上に導きます。"
      },
      {
        title:
          "クラウド授業準備とインタラクティブ授業の間のシームレス連携",
        name:
          "授業前に、教師は教育クラウドにある教材や資料などを適切に利用して授業を準備し、ワンクリック操作で準備内容を授業対象のクラスに送信します。授業する際に、ログインの後、直ちにクラウドから授業の準備内容を取り出すことができます。ネットワーク不安定などの状況に対応し、準備教材などを前もって授業用パソコンへ保存することも可能です。教室のLAN接続により正常通りに授業ができるので、教室内に必要以上のストレージデバイスを準備する必要はありません。"
      },
      {
        title:
          "ワンクリックで問題配布・リアルタイムに回答統計",
        name:
          "教師は授業中に問題を出し、生徒はリアルタイムに問題を受け取り、選択問題の回答を提出することができます。教師の端末に回答人数、平均正確率、解答分布、生徒の回答詳細など、生徒の回答状況が自動的に表示されます。"
      },
      {
        title:
          "リアルタイムに生徒の学習プロセスをモニタリングし生徒の学習状況を把握",
        name:
          "教師はモニタリング機能を利用して全ての生徒の学習状況をリアルタイムに把握することができます。対象の生徒がオンラインかどうか、ミュートかどうかをチェックし、生徒のPADの現在の表示画面を確認することもできます。複数の生徒の画面を並べてモニタリングすることもできます。"
      },
      {
        title: "授業の学習状況評価",
        name:
          "教師は該当クラスの生徒に対して個人やグループを管理し、随時に多面的評価を行うことができます。"
      },
      {
        title:"授業報告",
        name:"授業において各知識ポイントを把握する正確率、授業中の練習課題の正解率、回答の分布などを含めて、完全な授業報告を自動生成することができます。授業状況のレビューに役立ちます。"
      },
      {
        title: "授業クオリティの定量化",
        name:"教師と生徒がオンライン学習とオフライン学習における各プロセスの連携と有効利用を促し、あらゆる種類の教育データ分析サービスを提供することができます。教育研究者は教育状況の詳細を理解し、学習ダイナミックスをタイムリーに掌握することで、教学品質レベルの定量化を図ります。"
      }
    ],
    smartOne: {
      title: "スマート管理システム"
    },
    smartListOne: [
      {
        title: "スマート勤怠管理",
        name:
          "ディープラーニングのアルゴリズムに基づき、画像内の顔を検出し顔関連の特徴分析を行い、名前、役職、ログイン時間、表情などを含む多次元の顔情報を識別します。スマート勤怠管理を実現し、トータル的な勤怠レポートを自動生成することができます。例えば、参加者人数、出席人数、出席の統計分析など。"
      },
      {
        title: "スマート学習情況分析",
        name:
          "AI技術により教室現場の情況をリアルタイムにモニタリングすることができます。カメラは自動的にシャッターを取り、頭を下げたり、手をあげたり、振り返ったりする基本動作や複合動作を含め、生徒の行動を判別し分析することができ、レポートの自動作成を行うこともできます。 "
      },
      {
        title: "スマートデバイスコントロール",
        name:'リモートコントロール、情報収集、データ分析、データ監視・測定、データ統計、アラート通知などの機能を備えています。'
      },
      {
        title: "設備の一元管理とデータ統計分析",
        name:"当社のビッグデータを通じて、複数の教室に対して情報設備の稼働情況をモニタリングし分析することができます。例えば、教育素材や収録、配信などの設備使用回数、使用時間、設備の稼働エリアなどを調べ、多種多様なデータを可視化管理することができます。"
      }
    ],
    countentBox: "インテリジェント環境制御システム",
    countent: [
      {
        name:"スマート環境光制御システム:スマート調光システムにより空間内の光線の変化を認識し、設備の電力出力を自動的に調節することができます。設備をベストな稼働状態に維持することによって、生徒の近視を予防し、教師と生徒が自然で健康的な環境で授業に集中することが可能になります。"
      },
      {
        name:"スマート温度・湿度環境制御システム：空間環境の実際測定値および設定された目標値に基づき、エアコンまたは扇風機は自動的に調節し、空間の温度と湿度を自動コントロールすることができます。それによって、教室内は常に快適な空間環境を維持することができます。"
      },
      {
        name:"スマート空気質制御システム:CO2スマートセンサーモジュール、PM2.5 / PM10スマートセンサーモジュール、新鮮な空気を自動的に取り入れるスマート換気システム、スマート環境制御ターミナルなどによって構成されており、良質な教室の空気環境を確保することができます。"
      }
    ],
    k12OrHigherEdu: [
      'スマートスクール・ソリューションプラン（小・中学校）',
      'スマートスクール・ソリューションプラン（高等学校）',
    ],
  },

  //智能录制和广播解决方案
  intelligentRecord: {
    title:
      "ー 情報技術と人工知能を活用し、スマートキャンパスを構築 ー",
    titleOne: "INTELLIGENT RECORD AND BROADCASTING",
    titleTwo: "SOLUTION",
    bottomBox: "APPLICATION PACKAGE",
    threeBox:
      "The essence of micro-teaching course production is described in short, small, precise and professional.",
    easeTitle: "EASE OF USE",
    easeCount:
      "Ease of use is comprehensive and multi-layered. It can be segmented into user roles for a perfect experience.",
    bottomTitle:
      "The case consists of record and broadcasting equipment, image tracking all-in-one equipment, camera, smart blackboard, audio acquisition system, recording and broadcasting control system, teaching resource management platform and other products.",
    bottomTwoTitle:
      "The program is widely used in a variety of applications such as record and broadcasting classroom resource construction, teaching quality assessment, classroom monitoring system, safe campus and so on.",
    bottomThreeTitle:
      "This solution is widely used in a variety of application scenarios such as micro-class production, flipped classroom, and mobile learning.",
    bottomFourTitle:
      "This solution is applied to a variety of application scenarios such as the construction of teaching resources in schools, the promotion of teacher-student communication, and the balanced development of high-quality educational resources.",
    synopsis:
      "The 4K record and broadcasting classroom is built for recording high-quality courses, which can well reflect the unique teaching methods and advanced education concepts of the teachers. The system adopts multi-camera shooting to intelligently track and switch the video images of teachers teaching, students listening to lectures, teacher-student interaction scenes and classroom blackboard content. It is effective and necessary to create and disseminate excellent courses by recording classroom activities.",
    synopsisTwo:
      "The program supports the construction of teaching video resources by means of information technology, realizes large-scale cross-platform interaction, live broadcasting, on-demand and other Program applications. And it has centralized management, remote control, online course patrol and other functions, enhancing the utilization rate and coverage of information teaching equipment. It also can help schools to carry out teaching work such as making teaching video courses, evaluating teachers' teaching ability, remote observation, comments and academic exchanges, teaching research and helping and assisting teaching, which can let more excellent teaching resources be made and shared together.",
    synopsisThree:
      "Micro-teaching refers to the whole process of teaching around single or multiple knowledge points in the teaching process recorded by video as the main carrier. The classroom video clips and other auxiliary teaching resources related to the teaching theme including teaching design, materials, teaching reflections, practice tests, student feedback, teacher comments, consist its core components of micro-class. The whole contents organizes and presents in a certain way to create a semi-structured, simple and They are organized and presented in a certain way to create a semi-structured, simple and thematic small environment for the application of knowledge units.",
    synopsisFour:
      "At present, China is comprehensively promoting Internet+education mode, relying on the advantages of the Internet and other information technology, innovating school twinning support mechanism, and promoting the common construction and sharing of high-quality educational resources, to expand the radiation of high-quality educational resources, and realize the management of mutual aid schools, teaching and research, resource sharing, information sharing, teacher-student interaction, and complementary differences. At the mode, there are two teachers. One lecturer teacher teaches online, the other teacher manages students on site in the classroom on the listening side offline. This teaching mode gives full play to the advantages of both online and offline teachers and effectively improve the classroom efficiency and teaching quality, enabling students from different regions to enjoy the same quality education resources. Now, the remote dual-teacher classroom solution has been well received by schools and training institutions.",
    synopsisFive:
      "The rapid development of the Internet, AI, big data, 5G and other technologies has brought significant impact on education and teaching. Wenxiang is actively applying new information technology to innovate teaching organization mode, improve learning environment, develop digital education resources, accelerate the construction and application of intelligent learning environment, enhance the innovative ability of informationized teaching, and promote the deep integration of information technology and teaching. Based on this, Wenxiang launched a portable record and broadcasting construction solution, which adopts full wireless transmission technology and can be set up in 3 minutes, so that recording and broadcasting can be truly mobile and no longer restricted by the site environment. It realizes high-quality course resource production and relay, academic video presentation and conference, large-scale live streaming of course video, and distance education, and etc..",
    list: [
      "4K RECORD AND BROADCASTING CLASSROOM CONSTRUCTION PROGRAM",
      "NORMALIZED RECORD AND BROADCASTING CLASSROOM CONSTRUCTION PROGRAM",
      "PORTABLE RECORD AND BROADCASTING CONSTRUCTION PROGRAM",
      "MICRO-TEACHING ROOM CONSTRUCTION PROGRAM",
      "REMOTE DUAL-TEACHER CLASSROOM CONSTRUCTION PROGRAM"
    ],

    featuresList: [
      {
        title: "Safe and Stable",
        name:
          "All core devices are all adopts built-in DSP+ARM design based on Linux system, which has the characteristic of high stability, low consumption and maintenance-free."
      },
      {
        title: "Fully Automated Operation",
        name:
          'It supports automatic image tracking and screen switching, which lets the teacher focus on the teaching itself. The teacher can start classroom recording by "one-click". HD shooting, and professional audio acquisition and processing helps the entire teaching process for HD recording.'
      },
      {
        title: "AI Technology",
        name:
          'Based on a variety of AI technologies such as "teacher identity recognition", "face recognition" and "image intelligent recognition", Wenxiang has realized Program applications such as teacher height adaptive and speaker identity automatic recognition.'
      },
      {
        title: "New Automatic Tracking Mode",
        name:
          "The two tracking modes of group interaction and student listening behavior inspection are developed and designed according to the current popular group teaching mode, which can realize the automatic tracking and guidance of new teaching modes such as maker practice teaching, group class and future class."
      }
    ],

    featuresListTwo: [
      {
        title: "Simple Design",
        name:
          "Minimalist design supports wall-mounted installation, and does not take up classroom space."
      },
      {
        title: "All in one",
        name:
          "One normalized record and broadcasting equipment integrates the functions of multiple devices such as touch record and broadcasting host and remote interactive host, making the record and broadcasting device no longer be cumbersome."
      },
      {
        title: "High Performance and Ultra Stable",
        name:
          "The equipment adopts single-board design and built-in embedded system, supporting concurrent processing of multi-channel audio and video signals with strong performance, strong stability and durability."
      },
      {
        title: "4K Ultra HD Image Quality",
        name:
          "The camera uses 4K ultra-high-definition imaging technology, video analysis technology and electronic PTZ technology to make video shooting clearer and image tracking more accurate. And at the same time, it can achieve a single-dual scene, achieving 4 automatic tracking and switching by two cameras shoot, including teacher close-up and full view, student close-up and full view. The whole process without manual intervention provides a new recording experience and professional video effects."
      }
    ],

    featuresListThree: [
      {
        title: "Embedded Single-board Design",
        name:
          "Embedded single-board structure, and Linux system protect Windows from updates and viruses. The embedded architecture can also reduce the failure rate of the equipment. The power supply only needs 24V, which is low power consumption and low heat generation."
      },
      {
        title: "HD Audio Acquisition",
        name:
          "The audio signal of the instructor is picked up through the ceiling pickup microphone or collar microphone. The digital audio matrix processor performs noise reduction and audio equalization on the ambient sound to optimize the audio recording effect."
      },
      {
        title: "Easy and Automatic Operation",
        name:
          "With the control buttons on the micro-teaching panel, teachers can quickly start micro-teaching recording operations such as start, pause, pause, and live streaming. Once recording is completed, the video files can be automatically uploaded to the server with a single click, reducing redundant operations for teachers."
      },
      {
        title: "Online Video-editing",
        name:
          "Users can merge, edit and convert the video resources after login the resource management platform without downloading any client base. The edited videos can be uploaded to the resource management platform for sharing, which is convenient for students to learn."
      }
    ],

    featuresListFour: [
      {
        title: "3-minute Fast Installing",
        name:
          "Built-in embedded system can realize live streaming, on-demand and recording without plug-in. The whole installation of this system can be set up by simply selecting the location of the equipment and connecting the HD camera, portable record and broadcasting equipment, microphone and other accessories correctly. The whole system is easy to set up, which can be completed in 3 minutes, reducing the cumbersome operation steps and labor costs."
      },
      {
        title: "Portable and Easy Anytime and Anywhere",
        name:
          "The portable recording system is designed for temporary recording situations, with simple structure and easy movement. There is no need to set up a fixed recording classroom and it greatly saves the cost of users and realizes recording be finished at anywhere and anytime. The whole set of equipment can be easily carried by one person with designed fight case, and it is easy to move and record without any restrictions on location."
      },
      {
        title: "Guide Functions",
        name:
          "The guide function of the equipment is mainly used in the course of recording multiple scenes and multiple video signal sources, video/audio files and computer screen switching between."
      },
      {
        title: "Large Scale Live Streaming",
        name:
          "The device only needs to connect to the wireless network or mobile-phone hotspot. Then the program screen can be pushed to the whole network live streaming, and can automatically generate the live QR code, viewers can scan to watch the webcast."
      }
    ],

    featuresTwoList: [
      {
        title: "Remote Interaction",
        name:
          "It supports remote interaction and achieves cross-regional interactive teaching, visual network teaching and research and other remote interactive application mode."
      },
      {
        title: "Diversified Program Application Guide Management",
        name:
          "The equipment integrates video and audio acquisition, B/S web remote broadcasting, localized broadcasting, real-time recording, online live broadcasting, online on-demand, tracking and switching, equipment management and other Program application function, realizing simple operation and ensuring efficiency. In addition to computers, users can also log in to the platform through various mobile terminals, which breaks the restrictions of time and space."
      },
      {
        title: "Visual Educational Management",
        name:
          "The platform can carry out centralized control and unified management of each recording and broadcasting classroom, realizing equipment management, remote monitoring, online inspection, unsupervised examination and other Program applications. It provides visual teaching supervision and management platform for educational administrators."
      },
      {
        title: "Smart Docking Course Schedule",
        name:
          "Video automatically classified and stored, and resource management platform can be seamlessly connected with the school educational administration management system curriculum, which is easy to achieve automatic video release and archiving, forming a dynamic update of teaching resources."
      }
    ],

    featuresTwoListTwo: [
      {
        title: "Students",
        name:
          "It provides feedback on learning and carry out adaptive learning."
      },
      {
        title: "Teachers",
        name:
          "The system interface has been streamlined and optimized according to the actual use frequency of teachers, ensuring that teachers can easily get started like operating personal tablets, which ensures the accuracy of operation and let teachers focus on the teaching itself at the same time."
      },
      {
        title: "Audiovisual education administrator",
        name:
          "The product is highly integrated in design, making it easier to manage and maintain while reducing the failure rate."
      },
      {
        title: "School leaders",
        name:
          "It provides teaching information and data, comprehensively analyzes and scientifically grasp teaching status."
      }
    ],

    featuresThreeList: [
      {
        title: "Short",
        name:
          "The recording of high-quality micro-teaching video is generally produced for 5~8 minutes."
      },
      {
        title: "Small",
        name:
          "short time and small resource capacity ensure the quality of audio and video, and it is suitable for the dissemination and sharing of the mobile Internet era."
      },
      {
        title: "Precise",
        name:
          "The teaching content is concise, and it mainly highlights the essence of knowledge points."
      },
      {
        title: "Professional",
        name: "It has real-time and professional targeted knowledge points."
      }
    ],

    featuresFiveList: [
      {
        title: "Easy Operation",
        name:
          "The system is easy to operate and instructor do not have to change their original teaching habits."
      },
      {
        title: "Multi-point Interaction",
        name:
          "The system integrates multiple off-site classrooms into a teaching community, forming a cross-regional cloud classroom and achieving 1+N face-to-face online communication."
      },
      {
        title: "Smooth HD Experience",
        name:
          "The remote dual-teacher classroom solution uses new audio and video coding technology and supports a variety of interactive protocols to ensure that the audio and video interaction is clear and smooth."
      },
      {
        title: "Self-adapting to Complex Network",
        name:
          "It has advanced system algorithm, forward error correction(FEC) technology, frame loss compensation algorithm and Jitter buffering technology. Self-adaptive network and strong anti-packet loss capacity (more than 30%) guarantee low latency, clearness and smooth. And audio and video interaction effect is excellent. In the case of poor school network, the audio and video interaction can be carried out normally."
      },
      {
        title: "Real-time Analysis of Dual-teacher Classroom Data",
        name:
          "Comprehensive analysis of global data, including the number of online users and new users, the number of class sessions, classroom information (packet loss records/network latency records/network bandwidth/CPU utilization rate), etc. The platform analyzes the acquired data and presents it in a clear chart, which is easy for users to visualize and control."
      }
    ],

    featuresFiveListOne: [
      {
        title: "Easy Operation",
        name:
          "The system is easy to operate and instructor do not have to change their original teaching habits."
      },
      {
        title: "Multi-point Interaction",
        name:
          "The system integrates multiple off-site classrooms into a teaching community, forming a cross-regional cloud classroom and achieving 1+N face-to-face online communication."
      },
      {
        title: "Smooth HD Experience",
        name:
          "The remote dual-teacher classroom solution uses new audio and video coding technology and supports a variety of interactive protocols to ensure that the audio and video interaction is clear and smooth."
      },
      {
        title: "Self-adapting to Complex Network",
        name:
          "It has advanced system algorithm, forward error correction(FEC) technology, frame loss compensation algorithm and Jitter buffering technology. Self-adaptive network and strong anti-packet loss capacity (more than 30%) guarantee low latency, clearness and smooth. And audio and video interaction effect is excellent. In the case of poor school network, the audio and video interaction can be carried out normally."
      },
      {
        title: "Real-time Analysis of Dual-teacher Classroom Data",
        name:
          "Comprehensive analysis of global data, including the number of online users and new users, the number of class sessions, classroom information (packet loss records/network latency records/network bandwidth/CPU utilization rate), etc. The platform analyzes the acquired data and presents it in a clear chart, which is easy for users to visualize and control."
      }
    ],

    featuresFiveListTwo: [
      {
        title: "Network Courseware Production",
        name:
          "The system can automatically generate network courseware for network on-demand, which can be edited for deletion, synthesis, indexing, etc. It can also be imported into non-editing platform for professional editing. It is convenient for users to teach and learn comprehensive applications, high-quality courseware evaluation, etc."
      },
      {
        title: "Construction of High-quality Course Resource Library",
        name:
          "It can conduct a high-quality course resource library and provide an open management platform for schools to upload courseware."
      },
      {
        title: "Micro-teaching Assessment",
        name:
          "According to the needs of schools and the characteristics of micro-teaching, Wenxiang embeds the micro-teaching evaluation system in the recording system. Schools can evaluate the technical indicators in the system. And the content of the technical indicators can be modified according to the actual situation of the school. Objective and comprehensive evaluation of teachers' teaching skills can be reached through remote which can also train teachers various teaching skills and thus improve the teaching level."
      },
      {
        title: "Distance Learning Application",
        name:
          "Users can conduct live webcast and after-class on-demand, demonstration teaching, remote learning for students, and remote interactive teaching through the record and broadcasting system. Users can observe and learn at anytime and anywhere without any restriction."
      },
      {
        title: "Recording of Expert Lectures and Important Conferences",
        name:
          "Portable record and broadcasting system can truly realize all-round recording, which can record the whole process of various meetings, and the resources can be saved permanently, which can facilitate users to inquire and play the data after the meeting. The portable recording system is extremely suitable for various temporary meetings, lectures and training occasions."
      }
    ]
  },

  // 高教案例
  higherEdu: {
    title: "スマート教室・ソリューションプラン（高等教育）",
    content:"スマート教室プランはサービス教育を中心とした新型教室プランです。授業前、授業中、授業後のフルプロセスの教育内容をカバーし、メディア、コンテンツ、インタラクティブ連携・連動などの機能を一体化しました。特徴として教育内容の最適化、教室コミュニケーションの活性化、教育的資源の簡単利用などが挙げられます。そのほか、システムは状況認知、知能制御などの機能を備えており、健康的でスマート、高効率でエコな新型教室プランを構築することができます。",
    componentsTitle:'システムの構成',
    components:[
      'スマート黒板','スマート講義台　電動式','収録システム','学習行動分析システム','管理プラットフォーム','integrated design'
    ],
    features_title:'主な特長',
    featuresList: [
      {
        title: "スマート黒板",
        name:
          "Wenxiang smart blackboard integrates traditional blackboard, intelligent teaching system, multi-touch, HD LCD display, amplifier, speaker and other technologies. Through the five-finger screen technology, teachers can easily switch seamlessly between the traditional blackboard and the interactive display system, complete ordinary blackboard writing, electronic whiteboard interaction, teaching resource invocation, multimedia courseware demonstration and other operations."
      },
      {
        title: "アンチグレア、目の保護",
        name:
          "スマート黒板のガラス表面は、ナノコンポジットコーティングを施し、両眼に有害なブルーライト光源をカットし、教師と生徒の視力を保護してくれます。"
      },
      {
        title: "デュアルシステム",
        name:
          "Windows/Androidのデュアルシステムをプラットフォームとし、豊富な教育アプリケーションソフトが利用可能となります。"
      },
      {
        title: "豊富な教学資源",
        name:
          "多数のインタラクティブ電子黒板アプリや、動画、音楽、写真、PPTなど豊富な教育素材が付属されており、クラス授業にご活用いただけます。"
      }
    ],
    explanationList: [
      {
        title: "スマート全自動プレミアム収録／配信",
        name:
          "スマート教室には６台の全自動カメラにより構成されたプレミアム収録／配信システムを搭載しています。教師のクローズアップ・パノラマビュー、生徒のクローズアップ・パノラマビュー、黒板への板書、生徒モニタリングなど、マルチカメラによるビデオ撮影を行うことができます。全ての撮影や収録画面は高精細対応であり、フルハイビージョンを実現しています。"
      },
      {
        title: "グループ対話型授業　反転授業",
        name:
          "教師と生徒にオープンで自由な教育・学習空間と情報ツールを提供することによって、新たな教育モデルを創り出し、教師中心から生徒中心へと変革します。生徒はグループディスカッションにタイムリーに参加したり、画面共有したりすることができる一方、教師はリアルタイムにモニタリングしたり、コメントしたりすることができます。活発なコミュニケーションにより、教師は新しい知識を生徒にプレゼンすると同時に、生徒は学習内容への理解を深め、勉強への興味を高めることができます。"
      }
    ],
    explanationTitle:'スマート勤怠管理',
    explanationFourList: [
      {
        title: "スマート勤怠管理",
        name:
          "スマート勤怠管理：ディープラーニングのアルゴリズムに基づき、画像内の顔を検出し顔関連の特徴分析を行い、名前、役職、ログイン時間、表情などを含む多次元の顔情報を識別します。スマート勤怠管理を実現し、参加者人数、出席人数、出席の統計分析などを含むトータル勤怠レポートを自動生成することができます。"
      },
      {
        title: "スマート学習情況分析",
        name:
          "AI技術により教室現場の情況をリアルタイムにモニタリングすることができます。カメラは自動的にシャッターを取り、頭を下げたり、手をあげたり、振り返ったりする基本動作や複合動作を含め、生徒の行動を判別し分析することができ、レポートの自動作成もできます。"
      },
      {
        title: "スマートデバイスコントロール",
        name:
          "リモートコントロール、情報収集、データ分析、データ監視・測定、データ統計、アラート通知などの機能を備えています。"
      },
      {
        title: "設備の一元管理とデータ統計分析",
        name:
          "当社のビッグデータを通じて、複数の教室に対して情報設備の稼働情況をモニタリングし分析することができます。例えば、教育素材などの設備使用回数を調べたりして、多種多様なデータを可視化管理することができます。"
      }
    ],
    controlSystemsTitle: 'インテリジェント環境制御システム',
    controlSystem:[
      {
        name:"スマート環境光制御システム: スマート調光システムにより空間内の光線の変化を認識し、設備の電力出力を自動的に調節することができます。設備をベストな稼働状態に維持することによって、生徒の近視を予防し、教師と生徒が自然で健康的な環境で授業に集中することが可能になります。"
      },
      {
        name:"スマート温度・湿度環境制御システム：空間環境の実際測定値および設定された目標値に基づき、エアコンまたは扇風機は自動的に調節し、空間の温度と湿度を自動コントロールすることができます。それによって、教室内は常に快適な空間環境を維持することができます。"
      },
      {
        name:"スマート空気質管理システム: CO2スマートセンサーモジュール、PM2.5 / PM10スマートセンサーモジュール、新鮮な空気を自動的に取り入れるスマート換気システム、スマート環境制御ターミナルなどによって構成されており、良質な教室の空気環境を確保することができます。"
      }
    ]
  },
  // 常态化录播
  normalizedRecord:{
    title:"汎用型収録/配信システム・ソリューションプラン",
    content:"汎用型収録/配信システムは、教育現場においてITを活用したビデオ教育体制の構築をサポートします。大規模なプラットフォーム間の連携をはじめ、ライブ放送、オンデマンド、集中管理、遠隔操作、オンライン監督など様々な機能を備えています。このシステムを通じて、学校の教育用動画コンテンツ制作、教師の指導能力測定、遠隔モニタリング・評価、学術交流、教育研究、教育支援などを効率的に実現するとともに、優れた教育資源を共有することが可能になります。",
    componentsTitle:'システム構成',
    components: ['スマート黒板','汎用一体型収録/配信機','クラウド対応ミラー型カメラ（講師）','クラウド対応ミラー型カメラ（生徒）','ポインティングピックアップマイク','リソース管理プラットフォーム'],
    features_title:'主な特長',
    featuresList:[
      {
        title:'コンパクト',
        name:'シンプルなデザインで壁がけ設置にも対応します。教室のスペースはとりません。',
      },
      {
        title:'オールインワン',
        name:'収録／配信、遠隔インタラクション、タッチスクリーン、映像・音声処理、POEネットワーク交換など複数の設備の機能を集約し、シンプルに一体化しました。',
      },
      {
        title:'高性能・安定性',
        name:'シングルボードコンピューター設計を用いて、組み込みシステムを内蔵しています。複数のオーディオ・ビデオ信号を同時に処理することが可能であり、高性能で優れた安定性と耐久性を実現します。',
      },
      {
        title:'4K超高精細画質',
        name:'4K超高精細映像技術、ビデオ解析技術及び電子雲台技術を採用し、より鮮明な映像撮影と正確な画像追跡を行うことができます。',
      },
    ],
    easeOfUse:{
      title:'使いやすい',
      name:'ユーザーを細分化し、それぞれに対応した完璧なユーザーエクスペリエンスを提供します。'
    },
    texts:[
      {name:'教師：システムインターフェースは教師の実際の使用頻度などに合わせて合理化・最適化されています。教師は個人用タブレットを扱うように簡単に操作することが可能です。見た目の通りにアウトプットすることができるため、操作の正確性を容易に確保できます。それによって、教師は授業に専念できます。'},
      {name:'生徒：学習状況のフィードバックを確認することができるので、アダプティブラーニング（適応学習）が容易になります。'},
      {name:'eラーニング管理者：高度に集約されたシステム設計により、故障率を低減し、維持管理・メンテナンスが容易になります。'},
      {name:'学校指導者：教育情報がデータ化されることで、総合的且つ科学的な分析により、教学の状況を把握することができます。'},
    ]
  },
  // 4k精品录播
  record4k:{
    title:"プレミアム収録／配信システム・ソリューションプラン",
    content:"プレミアム収録／配信システムは、高精度な授業内容を収録・制作し、高品質な学習環境を構築することができます。複数カメラによるマルチ撮影を採用し、教師の授業や生徒の受講様子はもちろん、教師と生徒間のコミュニケーションや板書内容もAIによるトラッキングと自動的切り替え技術で収録することが可能であり、教師の特色ある指導方法や優れた教育理念をより適切に反映することができます。授業活動の完全記録と自動生成は、高品質な教育資源を効率的に構築することができます。優れた教育資源を共有し、教育水準の更なる向上を期待できます。",
    componentsTitle:'システムの構成',
    components: [
      'スマート黒板',
      'broadcasting <br/> equipment',
      '一体型画像トラッキング機 ',
      '高解像度カメラ',
      'directional <br/> microphone ',
      'デスクトップ型 タッチパネル',
      'リソース管理プラットフォーム',
      'デジタルオーディオプロセッサー'
    ],
    features_title:'主な特長',
    featuresList:[
      {
        title:'信頼性・安定性',
        name:'コア設備はすべて、Linuxシステムをベースに組込み式DSP+ARM構造の設計を採用しています。高い安定性、低い消費電力とメンテナンスフリーを特長としています。',
      },
      {
        title:'操作の全自動化',
        name:'完全自動トレッキング機能及び自動画面切替え機能を搭載し、ワンクリックで授業の収録を開始することができるので、教師はより授業に集中できるようになります。ハイビジョン撮影、プロ仕様の集音と音声処理は、高品質な授業プロセス記録を実現させることができます。',
      },
      {
        title:'AI技術',
        name:'教師プロフィールの識別、顔検出、インテリジェント画像認識など多種なAI技術をベースに、撮影における教師身長の自動合わせ、発言者の自動識別などを実現できます。',
      },
      {
        title:'新型自動トレッキング機能',
        name:'「グループインタラクション」や「生徒の受講様子のモニタリング」に採用された自動トレッキング技術は、現在注目されている「グループ指導教育モデル」に基づいて開発された機能で、様々な新型・未来型教育モデルに実践していただくことが可能です。',
      },
      {
        title:'遠隔インタラクション',
        name:'地域を越えた教育指導・コミュニケーションや、インターネット教育研究の可視化など様々な遠隔インタラクションアプリケーションに対応することができます。',
      },
      {
        title:'多種多様なアプリケーションの一体化管理',
        name:'撮影と録音、B/Sウェブリモート動画コンテンツの制作・配信、ローカルのコンテンツの制作・配信、リアルタイム収録・ライブ配信、インターネットオンデマンド配信、トラッキングと自動切り替え、設備管理など多種多様なアプリケーション機能を集約し、操作簡単、高速・効率化を実現しています。パソコンのほか、様々なモバイルデバイスも利用可能で、いつでもどこでもプラットフォームにアクセスできます。',
      },
      {
        title:'教務管理の可視化',
        name:'プラットフォームでは、各収録／配信教室に対して集中管理と統一管理が行われています。設備管理をはじめ、遠隔コントロール、オンラインモニタリング、無人試験監督などにご適用していただけるとともに、教務管理者に教学・監督管理の可視化プラットフォームを提供することができます。',
      },
      {
        title:'スケジュール管理の自動化',
        name:'ビデオの分類及び保存は自動的に行われると同時に、リソース管理プラットフォームは学校教務管理システムのスケジュールとシームレスに連携し、ビデオ公開とアーカイブの完全自動化を実現できます。',
      },
    ],
  },
  // 双师课堂
  dualTeacher:{
    title:"２名教師連携・ソリューションプラン",
    content:"「2名教師連携」プランとは、教師1名はオンラインにて、もう1名はオンサイトにて同じ教室を担当することです。それぞれの優位性を生かし補完することができるとともに、異なる地域の生徒には同等に良質な教育機会を与え、教育資源、情報を共有させることで、効率的に教育品質を高めることができます。",
    componentsTitle:'システムの構成',
    components: [
      'スマート黒板',
      '一体型録画放送機',
      'teacher’s <br/> cloud mirror camera ',
      'student’s <br/> cloud mirror camera ',
      '4Kプレミアム<br/>一体型録画放送機',
      'directional <br/> microphone ',
      'リソース管理プラットフォーム',
    ],
    features_title:'主な特長',
    featuresList:[
      {
        title:'マルチポイントでインタラクティブ交流',
        name:'複数の異なる地域の教室を一つの教学コミュニティに編成し、地域横断型「空中教室」を形成します。1+Nの「対面」コミュニケーションを実現することができます。',
      },
      {
        title:'スムーズなハイビジョン体験',
        name:'新型オーディオ及びビデオコーディング技術を採用し、多種多様なインタラクティブプロトコールに対応します。インタラクティブ音声及び映像の鮮明さと流暢さを確保することができます。',
      },
      {
        title:'複雑なネットワークに自動適応',
        name:'先進的なシステムアルゴリズム（前方誤り訂正機能(FEC)、フレーム損失補償アルゴリズム、ジッターバッファ技術など）を採用し、自動適応型ネットワークと強力なパケット損失防止容量(30%以上)により、低遅延、クリア性、流暢性が保証されます。また、ネットワーク環境が劣る場合でも、音声と映像のインタラクティブ連動を正常に行うことができます。',
      },
      {
        title:'リアルタイムデータ分析',
        name:'オンラインユーザー数、新規ユーザー数、授業回数、教室情報(パケットロス記録/ネットワーク遅延記録/ネットワーク帯域幅/CPU使用率)など、全体データを総合的に分析し、チャート形式でわかりやすくまとめ、ユーザーの可視化管理に役立ちます。',
      },
    ],
  },
  // AI 行为分析
  aiAnslysis:{
    title: "AI行動分析管理プラットフォーム",
    content:"当社の行動分析システムはAI技術により、教育現場の変化をタイムリーに察知することができます。インテリジェント行動分析ボックスによって自動的に撮影された教師や生徒の行動を解析し、レポートを自動生成することもできます。例えば、手を挙げた人数や頭を下げた人数、情緒的な行動のデータ統計など、授業中の教師や生徒の行動に対して分析を行い、生徒の学習状況を把握することができます。人工知能とビッグデータの精密な解析により、学校教育は単一から多元的に、クローズドからオープンになり、より個性化で特色ある教学を実現することができます。学校の基礎情報、生徒の行動データの収集、蓄積により、スマート学校の実現に重要なリソース資源を提供することができます。",
    features_title:'製品特徴',
    featuresList: [
      {
        title: "カリキュラムのワンクリック導入",
        name:''
      },
      {
        title: "授業現場のリアルタイムモニタリング",
        name:''
      },
      {
        title: "多種多様な可視化チャート",
        name:''
      },
      {
        title: "インテリジェント統計と解析",
        name:''
      },
      {
        title: "インテリジェント行動分析ボックス",
        name:''
      },
      {
        title: "ノイズレス",
        name:'組込み式ARM構造の採用により、ファンレス設計を実現し使用時に騒音はありません。'
      },
      {
        title: "ネットワークビデオアクセス",
        name:'教師と生徒の行動をリアルタイムに分析するために、2つ以上のネットワークビデオストリームアクセスを提供します。'
      },
      {
        title: "大規模な場面が分析可能",
        name:'PTZツアーをサポートし、分析ボックス内でモニタリング機能を設けており、大規模なシーンの分析に最適です。'
      },
      {
        title: "ローカルアウトプットに対応",
        name:'HDMIはローカルアウトプットに対応し、リアルタイムに結果の分析画面を確認することができます。'
      },
      {
        title: "標準的なインターフェースを使用",
        name:'1Mbpsイーサネットポートで標準HTTPインターフェースの採用により、学校の情報化システムに対応することができます。'
      },
      {
        title: "安全な電源供給",
        name:'行動分析ボックスは 12Vの電源を採用し、製品の安全使用を保証することが可能です。'
      }
    ],
  },
    // 便携录播
  portableRecord:{
    title:"ポータブル収録／配信システム・ソリューションプラン",
    content:"インターネット、人工知能、ビッグデータ、５G技術の急速な発展は、教育・教学に大きな変革をもたらしました。当社はこうした新しい情報技術を積極的に取り入れ、学習環境の改善、デジタル教育資源の開発、スマート学習システムの構築と応用、技術と教学の高度な融合による教育革新を加速化しています。さらに、当社は技術的優位性を活かし、ポータブル収録／配信システムを開発し、ワイヤレス伝送技術により３分で設備の接続・設定を完成させること可能になります。会場など環境の条件制限を受けずに収録・配信することができます。高品質な授業収録や制作、学術のビデオプレセンや会議、大規模な授業ライブや遠隔教学など、教育に関するさまざまな用途にご適用いただけます。",
    componentsTitle:'システムの構成',
    components: [
      'ポータブル録画放送機',
      'cloud mirror camera',
      'monopod sets',
      '無線全方向性マイクです',
      'public webcasting',
      'online vod',
    ],
    features_title:'主な特長',
    featuresList:[
      {
        title:'セットアップ簡単で３分で稼働開始',
        name:'一体型システム構成により、プラグインを必要とせずにライブ配信、オンデマンド配信、収録が可能になります。セットアップに関して、場所を選定した後に、ワイヤレスHD PTZカメラ、ポータブル収録／配信機、ワイヤレス全指向性マイクなどを正確に接続するだけで作業が完了します。セットアップは３分程度なので、煩雑な作業による手間ひまを省くことができます。',
      },
      {
        title:'いつでもどこでも収録／配信が可能',
        name:'構造がシンプルで移動が簡単。固定な教室を必要とせずに、その場で収録／配信を開始可能な用途に特化した設計です。システムに付属されたフライトケースは、キャスターやハンドルが付いており、一人でも全設備を持ち運ぶことが可能です。移動が簡単で場所の制限を受けずに、電源を入れればすぐに収録・配信をスタートすることが可能です。また、お客様のコストダウンにも繋がります。',
      },
      {
        title:'ナビゲーション機能',
        name:'ナビゲーション機能により、授業コースの収録／制作の過程において、複数の場面やチャンネル信号、ビデオ／オーディオファイル、コンピュータ画面などの切り替えをスムーズに行うことができます。',
      },
      {
        title:'大規模ストリミーング配信機能',
        name:'ストリミーング配信機能により、オープンネットワークに繋ぎ、大規模なライブ放送を実現することができます。ライブ放送のQRコードを自動生成することが可能で、携帯電話などでスキャンするだけでご視聴いただけます。',
      },
    ],
  },
  // 新闻
  news:{
    title:'ニュース',
    list:[
      {
        id:'news2',
        time:'2025.04.25',
        tag:'イベント',
        title:'AIを活用して教育を強化し、スマートラーニングの新時代を切り開く',
        contents:[
          {
            type:'html',
            content:'アジアで最も影響力のある教育技術のイベントであるEDIX Tokyoは、2025年4月23日から25日まで東京ビッグサイトで盛大に開催されました。日本の教育技術を牽引するブランド、BUNKAは「未来の学習空間を再構築する」というテーマのもと、全シーン対応のAIスマート教室ソリューション、スマート会議システム、革新的なハードウェア製品を披露し、デジタル教育の新たなビジョンを世界の観客に示しました。'
          },
          {
            type:'html',
            content:' AIスマート教室：よりスマートに、より効率的な授業へ'
          },
          {
            type:'img',
            content:'20250425-1.png'
          },
          {
            type:'html',
            content:'日本で初めて教育空間の全面的なスマート化を実現したサービスプロバイダーとして、BUNKAはAIスマート教室ソリューションにおいて三つの主要モジュールを提案しました。'
          },
          {
            type:'html',
            content:'4Kスマート収録システム。6台のカメラによる正確なトラッキングとAI分析を通じて、教師の授業、学生とのインタラクション、板書内容をリアルタイムで記録し、自動で分析レポートなどを生成。教育の最適化に向けたデータ支援を提供します。'
          },
          {
            type:'img',
            content:'20250425-2.png'
          },
          {
            type:'html',
            content:'軽量型収録システム。学校全体をカバーし、クロスプラットフォームでの高画質ライブ配信と録画をサポート。教育コンテンツの地域的な制約を打ち破ります。'
          },
          {
            type:'img',
            content:'20250425-3.png'
          },
          {
            type:'html',
            content:'スマート講義卓。従来の使用方法を最適化し、ワンタッチ操作による管理や電子黒板などの機能を統合。教師の操作負担を軽減します。'
          },
          {
            type:'html',
            content:'スマート会議システム：グローバルな協働をシームレスにつなぐ'
          },
          {
            type:'img',
            content:'20250425-4.png'
          },
          {
            type:'html',
            content:'BUNKAは、AI搭載のポータブル4K収録システムにより、ビジネス会議ソリューションの注目の存在となっています。本システムは迅速な導入が可能で、複数のカメラアングルやさまざまなシーンに対応。ZoomやTeamsなど主要なプラットフォームと高い互換性を持ち、AIによる音声のリアルタイム文字起こしや多言語翻訳機能と組み合わせることで、ビジネス会議をよりスムーズかつ効率的にします。'
          },
          {
            type:'img',
            content:'20250425-5.png'
          },
          {
            type:'html',
            content:'モバイル実習ソリューション：専門学校における職業教育の新たなサポータ'
          },
          {
            type:'img',
            content:'20250425-6.png'
          },
          {
            type:'html',
            content:'専門学校の職業教育ニーズに対応するため、BUNKAが提供する4Kモバイル実習システムは、そのモジュール化デザインと360°撮影機能で多くの注目を集めています。医療・看護、工学技術、飲食管理などの実習で、操作の詳細を同時に録画し、学生が核心スキルを迅速に習得できるよう支援します。'
          },
          {
            type:'html',
            content:'ハードウェア革新：授業体験の新たな進化'
          },
          {
            type:'img',
            content:'20250425-7.png'
          },
          {
            type:'html',
            content:'展示会の現場では、BUNKAがAI技術を搭載した複数のハードウェア製品を展示しました：'
          },
          {
            type:'html',
            content:'・メモリーボード。教師の板書の過程をリアルタイムで記録し、授業内容を完全に再現。学生の効率的な復習を支援します。'
          },
          {
            type:'html',
            content:'・スマートボードおよび一体型シリーズ。AIアルゴリズムを活用して文字の自動生成と変換を実現し、授業の効率を大幅に向上させました。Google EDLA認証により、世界中のユーザーに信頼できる選択肢を提供します。'
          },
          {
            type:'img',
            content:'20250425-8.png'
          },
          {
            type:'html',
            content:'BUNKAは、今回のEDIX Tokyoにおいて、スマート教育エコシステムの全体的なレイアウトを全面的に展示し、教育技術の革新における国際的な競争力を再度証明しました。今後、BUNKAはユーザーのニーズにさらに深く取り組み、革新的な技術で人と知識のつながり方を再定義し、すべての空間が知恵を引き出す舞台となるよう尽力します。'
          },
        ]
      },
      {
        id:'news1',
        time:'2024.1.31',
        tag:'イベント',
        title:'ヨーロッパ最大のAVインテグレーションイベント「2024年1月30日～2月2日Integrated Systems Europe(ISE)」に出展いたします',
        // content:`この度、BUNKAはヨーロッパ最大のAVインテグレーションイベントISE 2024 - Integrated Systems Europeに出展いたします。<br/>
        //   収録／放送機、スマート黒板やデジタルホワイトボード等、様々な製品・システムをご用意しております。<br/>
        //   皆様ぜひ弊社ブースにお立ち寄りくださいませ！<br/><br/>
        //   Booth #4H530<br/>
        //   Invitation Code:6HSCBNVI<br/><br/><br/>
        //   <a style='color:blue;' href='https://www.iseurope.org/ise-2024-conference-programme' target='_blank'>ISE 2024の詳細はこちらから</a>

        // `,
        contents:[{
          type:'html',
          content:`この度、BUNKAはヨーロッパ最大のAVインテグレーションイベントISE 2024 - Integrated Systems Europeに出展いたします。<br/>
          収録／放送機、スマート黒板やデジタルホワイトボード等、様々な製品・システムをご用意しております。<br/>
          皆様ぜひ弊社ブースにお立ち寄りくださいませ！<br/><br/>
          Booth #4H530<br/>
          Invitation Code:6HSCBNVI<br/><br/><br/>
          <a style='color:blue;' href='https://www.iseurope.org/ise-2024-conference-programme' target='_blank'>ISE 2024の詳細はこちらから</a>`
        }],
      },
    ]
  },
  backToMainMenu:'メインメニューに戻る'
};



// WEBPACK FOOTER //
// ./src/langs/jp.js